import api from "./api";
import { getArgs } from "../utils";

const route = "/class_reservations";

const ReservationsService = {
  getClassReservations: (filters) => api.get(`${route}?${getArgs(filters)}`),
  getReservationsRatings: (filters) =>
    api.get(`${route}/ratings?${getArgs(filters)}`),
  postReservation: (class_reservation) =>
    api.post(route, { ...class_reservation }),
  putReservacion: (class_reservation) =>
    api.put(route, { ...class_reservation }),
  postAttend: (class_reservation_id, attend) =>
    api.post(`${route}/attend/${class_reservation_id}`, { attend }),
  postAsistenteClase: (data) =>
    api.post(`${route}/admin`, {
      ...data,
    }),
  cancelReservation: (class_reservation_id) =>
    api.delete(`${route}/admin/${class_reservation_id}`),
};

export default ReservationsService;
